<div class="page-container">
    <div class="page-header"> 
        <button *ngIf="authService.isSuperAdmin" mat-button mat-icon-button onclick="this.blur()" (click)="goBack()">
            <mat-icon class="backArrow">navigate_before</mat-icon>
        </button>
        <span *ngIf="!currentCompany"> Client Dashboard  </span>
        <span *ngIf="currentCompany"> Dashboard {{currentCompany}} </span>
    </div> 
    <div style="display: flex; align-items: center; justify-content: space-between; width: 100%; margin-left: 8px;">
        <nav mat-tab-nav-bar>
            <a mat-tab-link
               *ngFor="let link of navLinks"
               [routerLink]="link.link"
               routerLinkActive #rla="routerLinkActive"
               [active]="rla.isActive"
               (click)="updateActiveLinkIndex(link.index)">
                {{link.label}}
            </a>
        </nav>
        <span readOnly [hide]="true" *ngIf="authService.isSuperAdmin">
            <button *ngIf="activeLinkIndex === 0"
            mat-flat-button color="primary" style="margin-right: 10px;" (click)="addNew('zone')"
            >Add Zone</button>
            <button *ngIf="activeLinkIndex === 0"
            mat-flat-button color="primary" style="margin-right: 10px;" (click)="addNew('sensor')"
            >Add Sensor</button>
            <button *ngIf="activeLinkIndex === 0" 
            mat-flat-button color="primary" style="margin-right: 10px;" (click)="addNew('gateway')"
            >Add Gateway</button>
            <button *ngIf="activeLinkIndex === 0" 
            mat-flat-button color="primary" style="margin-right: 10px;" (click)="addNew('cycle')"
            >Add Cycle</button>
            <!-- <button mat-flat-button color="primary" style="margin-right: 10px;" (click)="addNew('tunnel')"
            >Add Tunnel</button> -->
            <!-- <button *ngIf="activeLinkIndex == 0 || activeLinkIndex == -1"
            mat-flat-button color="primary" style="margin-right: 10px;" (click)="addNew('user')"
            >Add User</button> -->
        </span>
    </div>
    <router-outlet></router-outlet>
    <!-- <div class="loading-wrapper-top">
        <mat-spinner diameter="30" *ngIf="!zones"></mat-spinner>
    </div> -->
</div>